import { Grid, InputAdornment, Paper, Typography } from "@mui/material";
import { Controller, useFormContext } from "react-hook-form";

import { CustomDatePicker, CustomNumberField } from "@/features/ui";

export const BalanceInformationSection = () => {
  const { control } = useFormContext();
  return (
    <Paper sx={{ p: 3, borderRadius: 2 }}>
      <Typography variant="h6" gutterBottom>
        Informasi Saldo
      </Typography>

      <Grid container spacing={3}>
        {/* Saldo Awal */}
        <Grid size={{ xs: 12, sm: 6 }}>
          <Controller
            control={control}
            name="initialBalance"
            render={({ field, fieldState }) => (
              <CustomNumberField
                label="Saldo Awal"
                value={field.value}
                onChange={field.onChange}
                error={fieldState.invalid}
                helperText={fieldState.error?.message}
                fullWidth
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">Rp</InputAdornment>
                  ),
                }}
              />
            )}
          />
        </Grid>

        {/* Tanggal Efektif */}
        <Grid size={{ xs: 12, sm: 6 }}>
          <Controller
            control={control}
            name="initialBalanceEffectiveDate"
            render={({ field, fieldState }) => (
              <CustomDatePicker
                label="Tanggal Efektif"
                value={field.value}
                onChange={field.onChange}
                error={fieldState.invalid}
                helperText={fieldState.error?.message}
              />
            )}
          />
        </Grid>
      </Grid>
    </Paper>
  );
};
